// @flow
import React from 'react';
import { productColorSunflower, fontFamilies } from './designSystem.js';
import { Language } from './languages.js';

export function InternalHeading({
  level,
  color,
  children,
}: {
  level: number,
  color?: string,
  children: string | React$Element<typeof Language>,
}) {
  const style = {
    fontFamily: fontFamilies.gilroy.name,
    fontWeight: fontFamilies.gilroy.weights.extraBold,
    color: color ?? productColorSunflower.grey,
  };
  switch (level) {
    case 2:
      return <h2 style={{ ...style, fontSize: 28 }}>{children}</h2>;
    case 3:
      return (
        <h3 style={{ ...style, fontSize: 20, lineHeight: '24px' }}>
          {children}
        </h3>
      );
    default:
      throw Error('no valid level provided to <InternalHeading>');
  }
}
